module.exports = __webpack_public_path__ + "img/vertical_active.f14262de.svg";